import actionCreatorFactory from 'typescript-fsa'

import {
  AnswerToFacebookPostCommentRequest,
  DeleteFacebookPostCommentRequest,
  GetFacebookFeedForPageRequest,
  GetFacebookPostRequest,
  LikeFacebookPostCommentRequest,
  LikeFacebookPostRequest,
  UnlikeFacebookPostCommentRequest,
  UnlikeFacebookPostRequest,
  WriteFacebookPostCommentRequest,
} from '@3m5/sm_publish-frontend-api/apis/FacebookPostApi'

import { FacebookPage, FacebookPost, GetFacebookFeedResponse } from '@3m5/sm_publish-frontend-api/models'
import { GetFacebookPageRequest } from '@3m5/sm_publish-frontend-api/apis/FacebookPageApi'
import { DeletePostRequest } from '@3m5/sm_publish-frontend-api'

const actionCreator = actionCreatorFactory('FACEBOOK_POST')

/*
 * Actions
 */
export const getFacebookPageInitiated = actionCreator<GetFacebookPageRequest>('GET_FACEBOOK_PAGE_INITIATED')
export const getFacebookPage = actionCreator.async<GetFacebookPageRequest, FacebookPage>('GET_FACEBOOK_PAGE')

export const getFacebookFeedForPageInitiated = actionCreator<{ data: GetFacebookFeedForPageRequest, id: string }>('GET_FACEBOOK_FEED_FOR_PAGE_INITIATED')
export const getFacebookFeedForPage = actionCreator.async<GetFacebookFeedForPageRequest, GetFacebookFeedResponse>('GET_FACEBOOK_FEED_FOR_PAGE')

export const deletePostInitiated = actionCreator<DeletePostRequest>('DELETE_POST_INITIATED')
export const deletePost = actionCreator.async<DeletePostRequest, undefined>('DELETE_POST')

export const deleteFacebookPostCommentInitiated = actionCreator<DeleteFacebookPostCommentRequest>('DELETE_FACEBOOK_POST_COMMENT_INITIATED')
export const deleteFacebookPostComment = actionCreator.async<DeleteFacebookPostCommentRequest, FacebookPost>('DELETE_FACEBOOK_POST_COMMENT')

export const getFacebookPostInitiated = actionCreator<GetFacebookPostRequest>('GET_FACEBOOK_POST_INITIATED')
export const getFacebookPost = actionCreator.async<GetFacebookPostRequest, FacebookPost>('GET_FACEBOOK_POST')

export const likeFacebookPostInitiated = actionCreator<LikeFacebookPostRequest>('LIKE_FACEBOOK_POST_INITIATED')
export const likeFacebookPost = actionCreator.async<LikeFacebookPostRequest, FacebookPost>('LIKE_FACEBOOK_POST')

export const likeFacebookPostCommentInitiated = actionCreator<LikeFacebookPostCommentRequest>('LIKE_FACEBOOK_POST_COMMENT_INITIATED')
export const likeFacebookPostComment = actionCreator.async<LikeFacebookPostCommentRequest, FacebookPost>('LIKE_FACEBOOK_POST_COMMENT')

export const unlikeFacebookPostInitiated = actionCreator<UnlikeFacebookPostRequest>('UNLIKE_FACEBOOK_POST_INITIATED')
export const unlikeFacebookPost = actionCreator.async<UnlikeFacebookPostRequest, FacebookPost>('UNLIKE_FACEBOOK_POST')

export const unlikeFacebookPostCommentInitiated = actionCreator<UnlikeFacebookPostCommentRequest>('UNLIKE_FACEBOOK_POST_COMMENT_INITIATED')
export const unlikeFacebookPostComment = actionCreator.async<UnlikeFacebookPostCommentRequest, FacebookPost>('UNLIKE_FACEBOOK_POST_COMMENT')

export const writeFacebookPostCommentInitiated = actionCreator<WriteFacebookPostCommentRequest>('WRITE_FACEBOOK_POST_COMMENT_INITIATED')
export const writeFacebookPostComment = actionCreator.async<WriteFacebookPostCommentRequest, FacebookPost>('WRITE_FACEBOOK_POST_COMMENT')

export const answerToFacebookPostCommentInitiated = actionCreator<AnswerToFacebookPostCommentRequest>('ANSWER_TO_FACEBOOK_POST_COMMENT_INITIATED')
export const answerToFacebookPostComment = actionCreator.async<AnswerToFacebookPostCommentRequest, FacebookPost>('ANSWER_TO_FACEBOOK_POST_COMMENT_COMMENT')
